import { DISPLAY_MODES } from './stack-config'
import { TempSettings } from './types'

export const validateSettings = (tempSettings: TempSettings): string | null => {
  // Convert string values to numbers for validation
  const startValue = typeof tempSettings.tempStackStart === 'string'
    ? parseInt(tempSettings.tempStackStart, 10)
    : tempSettings.tempStackStart

  const endValue = typeof tempSettings.tempStackEnd === 'string'
    ? parseInt(tempSettings.tempStackEnd, 10)
    : tempSettings.tempStackEnd

  // Validate settings
  if (isNaN(startValue) || startValue < 1) {
    return 'Stack Start must be at least 1.'
  }
  if (startValue > 52) {
    return 'Stack Start must be no more than 52.'
  }
  if (isNaN(endValue) || endValue > 52) {
    return 'Stack End must be no more than 52.'
  }
  if (startValue >= endValue) {
    return 'The start value must be lower than the end value.'
  }

  // Validate timer settings
  const parsedTimer = typeof tempSettings.tempTimerSeconds === 'string'
    ? parseInt(tempSettings.tempTimerSeconds, 10)
    : tempSettings.tempTimerSeconds

  if (isNaN(parsedTimer) || (parsedTimer !== 0 && parsedTimer < 3)) {
    return 'Timer must be 0 (disabled) or at least 3 seconds.'
  }

  return null // No errors
}

export const processValidSettings = (tempSettings: TempSettings) => {
  const startValue = typeof tempSettings.tempStackStart === 'string'
    ? parseInt(tempSettings.tempStackStart, 10)
    : tempSettings.tempStackStart

  const endValue = typeof tempSettings.tempStackEnd === 'string'
    ? parseInt(tempSettings.tempStackEnd, 10)
    : tempSettings.tempStackEnd

  const parsedTimer = typeof tempSettings.tempTimerSeconds === 'string'
    ? parseInt(tempSettings.tempTimerSeconds, 10)
    : tempSettings.tempTimerSeconds

  // Auto-adjust timer for auto mode
  const newTimer = tempSettings.tempDisplayMode === DISPLAY_MODES.AUTO && parsedTimer === 0
    ? 3
    : parsedTimer

  return {
    mode: tempSettings.tempMode,
    stackStart: startValue,
    stackEnd: endValue,
    timerSeconds: newTimer,
    selectedStackName: tempSettings.tempSelectedStackName,
    displayMode: tempSettings.tempDisplayMode,
  }
}